export function setupMoengageUser(data) { //for user registration
  if (typeof window.Moengage !== "undefined") {
    window.Moengage.identifyUser(data._id);
    window.Moengage.add_first_name(data.name || "Guest");
    window.Moengage.add_mobile(data.mobileNo);
    window.Moengage.add_email(data.email);
    window.Moengage.add_user_attribute("collegeCity", data.collegeCity);
    window.Moengage.add_user_attribute("collegeName", data.collegeName);
    window.Moengage.add_user_attribute("collegeState", data.collegeState);
    window.Moengage.add_user_attribute("collegeYear", data.collegeYear);
    window.Moengage.add_user_attribute("country", data.country);
    window.Moengage.add_user_attribute(
      "countryCode",
      data.countryCode || "+91"
    );
    window.Moengage.add_user_attribute(
      "createdAt",
      data.createdAt || new Date()
    );
    window.Moengage.add_user_attribute("paidUser", data.isTrialUser || true);
    window.Moengage.add_user_attribute("preparingFor", data.preparingFor);
    window.Moengage.add_user_attribute("role", data.role || "");
    window.Moengage.add_user_attribute("Year", data?.batch?.year || "");
    window.Moengage.add_user_attribute("Version", data.version || "");
    window.Moengage.add_user_attribute("deviceType", "web");
    window.Moengage.add_user_attribute("isDevice", "web");
    console.log("✅ MoEngage user set up");
  } else {

    console.error("❌ MoEngage SDK not loaded yet.");
  }
}

// MoEngageStrings.js
// const MoEngageString = {
//   // Event Names shows here
//   login: "login", //otp verify
//   loginSuccess: "login_success",
//   logout: "logout",
//   register: "register",
//   updateProfile: "update_profile",
//   videolayering: "videolayering",
//   qbank: "qbank",
//   test: "test",
//   subscription: "subscription",
//   ViewedWebPage: "Viewed_Web_Page",
// };


export const MoEngageStringNew = {
  loginSuccess: "login_success",//done
  loginError: "login_error",//done

  registerSuccess: "register_success",//done
  registerError: "register_error",//done

  clickCta: "click_cta",
  viewProfile: "view_profile",//done
  profileUpdated: "profile_updated",//done

  viewVideo: "view_video",//done

  viewQB: "view_qb",//done
  viewContentQB: "view_content_qb",//done
  viewInstruction: "view_instruction",//done
  viewPerformance: "view_performance",//done
  viewQBAttempt: "view_qb_attempt",//done

  viewTestAttempt: "view_test_attempt",//done
  viewTest: "view_test",//done
  viewTestCategory: "view_test_category",//done



  viewPackageDetail: "view_package_detail",//done
  buyNow: "buy_now",//done
  packageSuccess: "package_success",//done
  packageError: "package_error",

  clickLogout: "click_logout",//done


};

// export const EventParams = {


//   register_success: ["profile_added", "course", "mds", "country", "prof", "batch"],
//   register_error: ["status"],



//   view_video: [],
//   view_content_video: [
//     "type",
//     "source",
//     "content_name",
//     "source_type",
//     "video_landing",
//     "subject_landing",
//     "topic_landing",
//     "resource"
//   ],

//   view_qb: [],
//   view_content_qb: [
//     "type",
//     "source",
//     "content_name",
//     "source_type",
//     "qb_landing",
//     "subject_landing",
//     "topic_landing",
//     "resource"
//   ],

//   view_instruction: ["type", "source", "content_id"],
//   view_performance: ["type", "content_id"],

//   view_popup: ["type"],
//   view_qb_attempt: ["qb_id", "parentLayerId", "per_question_time"],

//   view_screen: ["type"],

//   bookmark: ["type", "content_id", "add", "from"],
//   bookmark_other: ["type", "show_solution", "subject_count"],

//   search: ["text"],
//   filter: ["type"],
//   filter_apply: ["type", "subject_count"],

//   schedule: ["type", "batch_name", "batch_id"],
//   schedule_other: ["type", "batch_name", "batch_id", "subtype", "date"],

//   view_package_detail: ["package_id", "package_name"],//done
//   package_error: ["package_id", "package_name", "reason"],


//   video: [
//     "type",
//     "parentLayerId",
//     "videoId",
//     "videoCphierId",
//     "topic",
//     "version",
//     "duration",
//     "mode"
//   ],

//   video_controls: [
//     "type",
//     "quality_type",
//     "language",
//     "speed",
//     "mode",
//     "content_id",
//     "download_index"
//   ],

//   video_error: ["videoID", "userId", "playbackInfo", "otp", "code", "message"],


// };

//event to save on moengage
export function trackEvent(eventNameFromScreen, eventData) {
  console.log(eventNameFromScreen, "eventNameFromScreen")
  if (typeof window.Moengage !== "undefined") {
    const eventName = MoEngageStringNew[eventNameFromScreen];
    if (eventName) {
      console.log(eventName, eventData);//log event
      window.Moengage.track_event(eventName, eventData);
    }
  } else {
    console.error("❌ MoEngage SDK not loaded yet.");
  }
}
